export function capitalize(s: string): string {
  if (!s) {
    return s;
  }
  const trimmed = s.trimStart();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}

export function capitalizeWords(s: string): string {
  return s.replace(/(?<![\p{L}\p{N}])\p{L}/gu, (m) => m.toUpperCase());
}

export function escapeRegExpLiteral(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&");
}

export function toNullableTrimmedString(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed;
}
